import { useEffect, useState, useCallback } from "react";

const KEY = "md_cart";

const read = () => {
  try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
};

export const useCart = () => {
  const [cart, setCart] = useState(read);

  // Sync cross-tab and from other components
  useEffect(() => {
    const onStorage = (e) => { if (e.key === KEY) setCart(read()); };
    const onCustom = () => setCart(read());
    window.addEventListener("storage", onStorage);
    window.addEventListener("md-cart-change", onCustom);
    return () => {
      window.removeEventListener("storage", onStorage);
      window.removeEventListener("md-cart-change", onCustom);
    };
  }, []);

  const persist = useCallback((next) => {
    localStorage.setItem(KEY, JSON.stringify(next));
    setCart(next);
    window.dispatchEvent(new Event("md-cart-change"));
  }, []);

  const add = useCallback((p) => {
    const cur = read();
    const ex = cur.find((c) => c.id === p.id);
    const next = ex
      ? cur.map((c) => c.id === p.id ? { ...c, qty: c.qty + 1 } : c)
      : [...cur, { id: p.id, name: p.name, price: p.price, image_url: p.image_url, qty: 1 }];
    persist(next);
  }, [persist]);

  const dec = useCallback((id) => {
    const next = read().map((c) => c.id === id ? { ...c, qty: Math.max(0, c.qty - 1) } : c).filter((c) => c.qty > 0);
    persist(next);
  }, [persist]);

  const remove = useCallback((id) => {
    persist(read().filter((c) => c.id !== id));
  }, [persist]);

  const clear = useCallback(() => persist([]), [persist]);

  const count = cart.reduce((s, c) => s + c.qty, 0);
  const total = cart.reduce((s, c) => s + c.price * c.qty, 0);

  return { cart, count, total, add, dec, remove, clear };
};
